import { forEach, isObject } from 'lodash';

import * as atlasOps from '../api/Atlas/atlas-operations';

/**
 * Gets the default value for the forms from the existing atlas, if exists.
 *
 * @param {object} arg - The object argument.
 * @param {string} arg.atlas - The atlas object.
 * @param {string} arg.element - The name of the atlas element to get the default values.
 * @param {string} arg.elementIndex - The index of the element on the structure array.
 * @returns {object[]} - An array containing objects with the form name and the default value.
 */
const getDefaultValuesForForms = ({ atlas, element, elementIndex }) => {
  const defaultValues = [];
  const existingAtlas = atlasOps.getId(atlas);
  if (existingAtlas) {
    const atlasProps = atlasOps.getAtlasProps(atlas)[elementIndex];
    forEach(atlasProps, ({ propName, propValue }, propIndex) => {
      const formName = `${element}-${propIndex}-prop-${propName}`;
      if (isObject(propValue)) {
        const { elementName: childElement, elementProps: childProps } = propValue;
        defaultValues.push({ formName, defaultValue: childElement });
        forEach(
          childProps,
          ({ propName: childPropName, propValue: childPropValue }, childPropIndex) => {
            const childFormName = `${formName}-${childElement}-${childPropIndex}-prop-${childPropName}`;
            defaultValues.push({ formName: childFormName, defaultValue: childPropValue });
          }
        );
      } else {
        defaultValues.push({ formName, defaultValue: propValue });
      }
    });
  }
  return defaultValues;
};

export default getDefaultValuesForForms;
